import { render, staticRenderFns } from "./ContactRelationDetail.vue?vue&type=template&id=5ab36bb4&"
import script from "./ContactRelationDetail.vue?vue&type=script&lang=js&"
export * from "./ContactRelationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports